import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { useLocation, matchPath } from 'react-router-dom'
import { useModal } from '@gluedigital/modal'
import { useUserActions } from 'src/hooks/api'
import Loading from 'src/components/Loading/Loading'

const SimpleSupportForm = () => {
  const [status, setStatus] = useState('idle')
  const [description, setDescription] = useState('')
  const modal = useModal()
  const actions = useUserActions()

  const loc = useLocation()
  const match = matchPath<any>(loc.pathname, { path: '/assets/:assetId' })
  const assetId = match?.params?.assetId

  const handleSubmit = async e => {
    e.preventDefault()
    setStatus('loading')
    try {
      await actions.contact({ description, assetId })
      setStatus('done')
    } catch (e) {
      console.warn('Contact error:', e)
      setStatus('error')
    }
  }

  if (status === 'loading') {
    return (
      <form className="ssf loading">
        <Loading />
      </form>
    )
  }

  if (status === 'done') {
    return (
      <form className="ssf done">
        <div className="main">
          <span className="icon icon-chat" />
          <h1><FormattedMessage id="client-support-modal.simple-form.done-title" /></h1>
          <p><FormattedMessage id="client-support-modal.simple-form.done-intro" /></p>
        </div>
        <div className="buttons">
          <button type="button" onClick={() => modal.hide()}>
            <FormattedMessage id="client-support-modal.simple-form.close" />
          </button>
        </div>
      </form>
    )
  }

  if (status === 'error') {
    return (
      <form className="ssf error">
        <div className="main">
          <span className="icon icon-close" />
          <h1><FormattedMessage id="client-support-modal.simple-form.error-title" /></h1>
          <p><FormattedMessage id="client-support-modal.simple-form.error-intro" /></p>
        </div>
        <div className="buttons">
          <button type="button" onClick={() => modal.hide()}>
            <FormattedMessage id="client-support-modal.simple-form.close" />
          </button>
        </div>
      </form>
    )
  }

  return (
    <form className="ssf" onSubmit={handleSubmit}>
      <h1><FormattedMessage id="client-support-modal.simple-form.title" /></h1>
      <p><FormattedMessage id="client-support-modal.simple-form.intro" /></p>
      <FormattedMessage id="client-support-modal.simple-form.placeholder">
        {(placeholder: any) =>
          <textarea
            value={description}
            onChange={e => setDescription(e.target.value)}
            required
            placeholder={placeholder}
          />
        }
      </FormattedMessage>
      <div className="buttons">
        <button>
          <FormattedMessage id="client-support-modal.simple-form.next" />
        </button>
      </div>
    </form>
  )
}

export default SimpleSupportForm
